import { SidebarMenuButton, SidebarMenuItem } from '@talentmesh/ui/components/sidebar';
import { cn } from '@talentmesh/ui/lib/utils';
import { type To } from 'react-router';
import { Link } from 'react-router-dom';

interface LineMenuButtonProps {
    isActive: boolean | 'never';
    to?: To;
    count?: number;
    buttonProps?: React.ComponentProps<typeof SidebarMenuButton>;
}

const LineMenuItem = ({ isActive, to, children, buttonProps }: React.PropsWithChildren<LineMenuButtonProps>) => {
    return (
        <SidebarMenuItem className="relative flex">
            <div
                className={cn(
                    'bg-primary absolute inset-0 my-auto h-4/5 w-0.75 rounded-full',
                    isActive === 'never'
                        ? 'bg-transparent'
                        : !isActive &&
                              'group-hover/menu-item:bg-primary/25 group-active/menu-item:bg-primary/50 bg-transparent',
                )}
            />
            <SidebarMenuButton
                asChild={!!to}
                isActive={isActive !== 'never' && isActive}
                variant="talentmesh"
                {...buttonProps}
                className={cn('mx-2 h-auto max-h-8 min-h-8 py-1.5', buttonProps?.className)}
            >
                {to ? <Link to={to}>{children}</Link> : children}
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default LineMenuItem;
